<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import myHeader from "@/components/head_foot/myHeader.vue";
import myFooter from "@/components/head_foot/myFooter.vue";
import myPage from "@/components/head_foot/page.vue";
export default {
  components: { myHeader, myFooter, myPage },
  data() {
    return {};
  },

  mounted() {
    const _hmt = _hmt || [];
    const hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?ac3a544aec0b438f9e0db22076d7b2ab";
    const s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);

    const c = document.createElement("script");
    c.type = "text/javascript";
    c.src =
      "https://dbt.zoosnet.net/JS/LsJS.aspx?siteid=DBT47295187&float=1&lng=cn";
    document.body.appendChild(c);

    //     通信测试仪器      交直流电源      电子负载      LCR测试仪      扫频仪      功率计
    // 高性能测试仪器      电路参数测量仪器      频率计      测量探头及附（配）件      逻辑分析仪
    // 功率分析仪      电能质量分析仪      超声波电源      测厚仪      信号发生器      场强仪
    // 示波器      安规测试仪      射频/微波测试仪      其它测量仪器      温度计      数据记录仪
    // 波形发生器      频谱分析仪      网络分析仪      测距仪      音频分析仪
  },

  methods: {},
};
</script>
<style lang="less">
#app {
  min-height: 100vh;
  position: relative;
  background: #f4f4f4;
  min-width: 1200px;
}
.apphead {
  background: #fff;
}
.appBottom {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.appback {
  background: #f4f4f4;
  padding-top: 10px;
}
html,
body {
  margin: 0;
  padding: 0;
  font-family: Microsoft YaHei;
}
.myFooterDiv {
  padding-bottom: 388px;
  background: #333333;
}
.dis {
  display: flex;
  align-items: center;
}
.disbet {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.apptitle {
  span {
    display: inline-block;
    width: 3px;
    height: 15px;
    background: #e1251b;
    margin-right: 8px;
  }
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #181818;
}
.appnot {
  text-align: center;
  color: #999;
}
.apptext {
  /*1.这个单词的意思是如果文字显示不开也必须强制一行内显示*/
  white-space: nowrap;
  /*2.溢出部分隐藏起来*/
  overflow: hidden;
  /*3.文字溢出的时候用省略号来显示*/
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/App.vue